export default {
  title: {
    en: 'Your changes have been saved',
  },
  text: {
    en: 'Would you like to re-activate your subscription?',
  },
  buttonTitle: {
    en: 'Resubscribe',
  },
}
